export enum AccuracyProviderDropdownTypes {
  Network = "network",
  Prospect = "prospect",
  Market = "market",
}

export enum AccuracySupplementalRowTypes {
  Undefined = "undefined",
  Source = "source",
  Valid = "valid",
  Unknown = "unknown",
  Invalid = "invalid",
  Enriched = "enriched",
  Result = "result",
}

export enum AdequacyAggregateType {
  Unknown = "unknown",
  RegionSet = "regionSet",
  SpecialtyGroup = "specialtyGroup",
}

export enum AdequacyAggregateGranularity {
  Unknown = "unknown",
  MultiRegion = "multiRegion",
  State = "state",
  CBSA = "cbsa",
  County = "county",
  CountyZip = "countyZip",
  Zip = "zip",
  ServiceArea = "serviceArea",
}

export enum ExportFormatType {
  Unknown = "unknown",
  CSV = "csv",
  Tab = "tab",
  Pipe = "pipe",
  Excel = "excel",
  CompressedBinary = "compressedBinary",
  Png = "png",
  Pdf = "pdf",
  Jpeg = "jpeg",
}

export enum ReportFormatType {
  Default = "default", // this is not HSD
  MA = "ma", // this is HSD
  MMP = "mmp", // this is HSD
  CCIIO_PPF_REPORT = "cciio_ppf_report", // this is not HSD
  DISTINCT_SERVICING_PROVIDER_REPORT = "distinct_servicing_provider_report", // this is not HSD
}

export enum ExportType {
  Unknown = "unknown",
  RegionAggregate = "regionAggregate",
  SpecialtyAggregate = "specialtyAggregate",
  CountyAggregate = "countyAggregate",
  StateAggregate = "stateAggregate",
  SpecialtyAggregateVolume = "specialtyAggregateVolume",
  AllSpecialties = "allSpecialties",
  SpecialtySummaryByRegion = "specialtySummaryByRegion",
  SpecialtySummaryByCounty = "specialtySummaryByCounty",
  ServicingProviders = "servicingProviders",
  AccuracyDetail = "accuracyDetail",
  AllInspections = "allInspections",
  ActionableProviders = "actionableProviders",
  NewProviderReport = "newProviderReport",
  ZipSummary = "zipSummary",
  ClosestProvider = "closestProvider",
  StatusReport = "statusReport",
  ZipAnalysisResultsReport = "zipAnalysisResultsReport",
  ZipClassAggregateResultsReport = "zipClassAggregateResultsReport",
  ZipAnalysisAdequacyServicingProvider = "zipAnalysisAdequacyServicingProvider",
}

export enum ExportGapFilterType {
  Unknown = "unknown",
  All = "all",
  Gaps = "gaps",
  FillableBySingleProvider = "fillableBySingleProvider",
  Exceptions = "exceptions",
  FillableGaps = "fillableGaps",
  GapResolutionStatus = "gapResolutionStatus",
  NotMeetingAccess = "notMeetingAccess",
}

export enum ExportProviderAvailabilityType {
  Unknown = "unknown",
  All = "all",
  Available = "available",
  Changed = "changed",
  Targeted = "targeted",
  Excluded = "excluded",
}

export enum NetworkProviderFilterType {
  Unknown = "unknown",
  Available = "available",
  Terminated = "terminated",
  Unterminated = "unterminated",
}

export enum NetworkProviderComparisonType {
  Added = "added",
  Removed = "removed",
  Matched = "matched",
}

export enum PractitionerStatuses {
  Practicing = "practicing",
  Retired = "retired",
  Unknown = "unknown",
}

export enum NppesStatuses {
  Active = "active",
  Deactivated = "deactivated",
  Invalid = "invalid",
}

export enum LocationStatuses {
  Open = "open",
  Closed = "closed",
  NoLongerOnRoster = "noLongerOnRoster",
  TermedOnRoster = "termedOnRoster",
  ServiceLocationNotAtThisAddress = "serviceLocationNotAtThisAddress",
  Unknown = "unknown",
}

export enum PractitionerAtLocationStatuses {
  PracticingAtOffice = "practicingAtOffice",
  LeftOffice = "leftOffice",
  DifferentPracticeAtSameAddress = "differentPracticeAtSameAddress",
  NotAtDepartment = "notAtDepartment",
  NotFoundOnRoster = "notFoundOnRoster",
  NoLongerOnRoster = "noLongerOnRoster",
  TermedOnRoster = "termedOnRoster",
  PractitionerNotRecognized = "practitionerNotRecognized",
  LocationClosed = "locationClosed",
  SamePracticeDifferentAddress = "samePracticeDifferentAddress",
  Unknown = "unknown",
}

export enum ReportSettingsType {
  Unknown = "unknown",
  AccuracyActionableProviders = "accuracyActionableProviders",
  AccuracyAllInspections = "accuracyAllInspections",
  AccuracyServicingProviders = "accuracyServicingProviders",
  AccuracySpecialtySummaryByRegion = "accuracySpecialtySummaryByRegion",
  AccuracyStatusReport = "accuracyStatusReport",
  AccuracySummariesDetail = "accuracySummariesDetail",
  AdequacyCountyAggregate = "adequacyCountyAggregate",
  AdequacyStateAggregate = "adequacyStateAggregate",
  AdequacySpecialtyAggregateVolume = "adequacySpecialtyAggregateVolume",
  ZipCodeServicingProviders = "zipCodeServicingProviders",
}

export enum BasicOperatorType {
  Unknown = "Unknown",
  Equal = "=",
  NotEqual = "<>",
  Less = "<",
  LessEqual = "<=",
  Greater = ">",
  GreaterEqual = ">=",
  In = "In",
  NotIn = "Not In",
  IsNull = "Is Null",
  IsNotNull = "Is Not Null",
  IsEmpty = "Is Empty",
  IsNotEmpty = "Is Not Empty",
  StartsWith = "Starts With",
  EndsWith = "Ends With",
  Contains = "Contains",
  NotContains = "Does Not Contain",
}

export enum LogicalOperatorType {
  Unknown = "Unknown",
  And = "And",
  Or = "Or",
}

export enum MembershipType {
  Unknown = "Unknown",
  Primary = "Primary",
  Secondary = "Secondary",
  Both = "Both"
}

